import { escapeHtml, safeUrl } from '../escape.js';
import { editAttr, itemStr, labeledIntro, list, sectionOpen, str } from './helpers.js';
import type { PatternSectionT } from '../../schema/index.js';

/** hero — primary variant `centered`: label, H1, subtitle, buttons, bg image. */
export function renderHero(section: PatternSectionT): string {
  const { fields } = section;
  const label = str(fields, 'label');
  const heading = str(fields, 'heading');
  const subtitle = str(fields, 'subtitle');
  const imageUrl = str(fields, 'image_url');

  const buttons = list(fields, 'buttons_data')
    .map((item, index) => {
      const text = itemStr(item, 'text');
      const url = itemStr(item, 'url');
      if (!text || !url) return '';
      const kind = index === 0 ? 've-btn--primary' : 've-btn--secondary';
      const textPath = `/buttons_data/${index}/text`;
      return `<a class="ve-btn ${kind}" href="${safeUrl(url)}"${editAttr(section, textPath)}>${escapeHtml(text)}</a>`;
    })
    .filter(Boolean)
    .join('\n      ');

  const parts: string[] = [sectionOpen(section)];
  if (imageUrl) {
    parts.push(`  <div class="ve-hero__bg"><img src="${safeUrl(imageUrl)}" alt=""${editAttr(section, '/image_url')}></div>`);
  }
  parts.push('  <div class="ve-hero__content">');
  parts.push(...labeledIntro(section, 'hero', heading, label, 'h1', '    '));
  if (subtitle) parts.push(`    <p class="ve-hero__subtitle"${editAttr(section, '/subtitle')}>${escapeHtml(subtitle)}</p>`);
  if (buttons) parts.push(`    <div class="ve-hero__actions">\n      ${buttons}\n    </div>`);
  parts.push('  </div>', '</section>');
  return parts.join('\n');
}
